import { AxInit, ModuleName } from '../../Lib/AxSystem/AxInit';
import { AxLoad } from '../../Lib/AxSystem/AxLoad';
import { AxStaticConfigModule } from '../AxConfig/AxStaticConfigModule';

const silent = { silent: true };

@ModuleName("AxGA4Module")
export class AxGA4Module implements AxInit {
    public initData: AxGA4initDataListIdAndListName;
    AxInit(init: AxGA4initDataListIdAndListName) {
        if (!AxStaticConfigModule.GA4Enabled) { return };
        this.initData = init;
        if (this.initData.caller == 'ThankYou') {
            this.purchase(this.initData.items);
        };

        const calls: {action: string, caller: string, data?: AxGA4initDataListIdAndListName | any[]}[] = [
            { action: 'purchase', caller: 'ThankYou', data: this.initData.items },
            { action: 'sendData', caller: 'Category', data: this.initData },
            { action: 'sendData', caller: 'TicketsV4Index', data: this.initData },
            { action: 'sendData', caller: 'TicketTypes', data: this.initData },
            { action: 'sendData', caller: 'Rental', data: this.initData },
            { action: 'sendData', caller: 'Date', data: this.initData },
            { action: 'sendData', caller: 'TicketNonPredateAble', data: this.initData },
            { action: 'sendData', caller: 'TicketPredateAble', data: this.initData },
            { action: 'sendData', caller: 'PackagePredateAble', data: this.initData },
            { action: 'sendData', caller: 'PackageNonPredateAble', data: this.initData },
            { action: 'sendData', caller: 'TicketsDescription', data: this.initData },
            { action: 'lessonsInfo', caller: 'Lessons', data: this.initData.items },
            { action: 'lessonsInfo', caller: 'Lesson', data: this.initData.items },
            { action: 'quantityBookNow', caller: 'TicketsQuantityBookNow', data: this.initData.items },
            { action: 'quantityBookNow', caller: 'PackageQuantityBookNow', data: this.initData.items },
            { action: 'calendarBookNow', caller: 'TicketsCalendarBookNow', data: this.initData.items },
            { action: 'calendarBookNow', caller: 'PackagesCalendarBookNow', data: this.initData.items },
            { action: 'goToBag', caller: 'Go To Bag' },
            { action: 'getPaymentInfo', caller: 'Resort charge' },
            { action: 'addToCart', caller: 'Add to Cart' },
        ];
        calls.forEach((call) => {
            if (this.initData.caller === call.caller) {
                this[call.action](call.data);
            }
        });

        if (this.initData.caller == 'Go To Bag' || this.initData.caller == 'Refresh ShoppingCart entries') {
            let proceedToCheckout = document.querySelector('[data-shoppingcart="proceed"]');
            if (proceedToCheckout != null) {
                proceedToCheckout.addEventListener('click', onclick, false);
                $('[data-shoppingcart="proceed"]').on('click', () => {
                    this.proceedToCheckoutGA4();
                });
                let deleteItem = document.querySelector('.delete-position');
                document.querySelector('.delete-position');
                if (deleteItem != null) {
                    let elem = document.querySelectorAll('a[data-position-id]');
                    elem.forEach(e => {
                        if (e.classList.contains('delete-position')) {
                            e.addEventListener('click', onclick, false);
                            $(e).click((x) => {
                                this.removeItemFromCart(x.currentTarget.getAttribute("data-position-id"));
                            });
                        }
                    })
                }
            }
        };

        if (this.initData.caller == 'RentalIndex') {
            this.sendData(this.initData);
            let rentalIndexMenu = document.querySelector('.ticketGroupCollapse');
            rentalIndexMenu.addEventListener('click', onclick, false);
            $('.ticketGroupCollapse').on('click', (e) => {
                let dataTarget = document.querySelector(e.currentTarget.getAttribute("data-target"));
                if (dataTarget != null) {
                    if (dataTarget.hasAttribute('package')) {
                        this.rentalMenuGA4(dataTarget.getAttribute("data-item"), "package");
                    }
                    else {
                        this.rentalMenuGA4(dataTarget.getAttribute("data-item"), "rental");
                    }
                }
            });
        };

        $('.package-selection').on('click', (e) => {
            this.getGridderDataForPackage(e.currentTarget.getAttribute("data-packageNr"), e.currentTarget.getAttribute("data-TariffSheetNrriff"));
        });
        $('.rental-selection').on('click', (e) => {
            this.getGridderDataForRental(e.currentTarget.getAttribute("data-rental"));
        });
    }

    getPaymentInfo() {
        AxessViewer.loadPartialView('/GA4TagManager/GA4AddPaymentInfoResult', "", (resp) => {
            let data: AxGA4initDataExtendedWithPaymentType = {
                items: resp.gTMEcommerce.ecommerceData.items,
                event: resp.gTMEcommerce.Event,
                caller: 'GA4AddPaymentInfoResult',
                value: resp.gTMEcommerce.ecommerceData.value,
                currency: resp.gTMEcommerce.ecommerceData.currency,
                payment_type: resp.gTMEcommerce.ecommerceData.paymentType,
                coupon: resp.gTMEcommerce.ecommerceData.coupon
            };
            this.sendDataExtendedWithPayment(data);
        }, silent);
    }

    addToCart() {
        let data = {};
        AxessViewer.loadPartialView('/GA4TagManager/GA4AddItemToCartResult', data, (resp) => {
            let data: AxGA4initDataExtendedCurAndVal = {
                items: resp.gTMEcommerce.ecommerceData.items,
                event: resp.gTMEcommerce.Event,
                caller: 'AddToCart',
                value: resp.gTMEcommerce.ecommerceData.value,
                currency: resp.gTMEcommerce.ecommerceData.currency
            };
            this.sendDataExtended(data);
        }, silent);
    }

    parseRentalItem(rentalItemParam: RentalSingleItemParam): RentalSingleItemParam {
        let param: RentalSingleItemParam = { RentalNr: rentalItemParam.RentalNr, ValidFrom: JSON.parse(rentalItemParam.ValidFrom), ValidTo: JSON.parse(rentalItemParam.ValidTo) }
        return param;
    }

    rentalMenuGA4(value: string, packOrRental: string) {
        if (packOrRental == 'package') {
            let jsonObj: RentalPackageParamCollection;
            jsonObj = JSON.parse(value);
            let data = {
                itemParamCollection: jsonObj
            };
            AxessViewer.loadPartialView('/GA4TagManager/GA4RentalPackagesResult', data, (resp) => {
                this.initData = {
                    item_list_id: resp.gTMEcommerce.ecommerceData.item_list_id,
                    item_list_name: resp.gTMEcommerce.ecommerceData.item_list_name,
                    items: resp.gTMEcommerce.ecommerceData.items,
                    event: resp.gTMEcommerce.Event,
                    caller: 'RentalPackagesViewList'
                };
                this.sendData(this.initData);
            }, silent);
        } else {
            let jsonObj: RentalItemParamCollection = JSON.parse(value);
            let parsedObject: RentalItemParamCollection = { ItemParams: [] };
            jsonObj.ItemParams.forEach(e => {
                parsedObject.ItemParams.push(this.parseRentalItem(e));
            });
            let data = {
                itemParamCollection: parsedObject
            };
            AxessViewer.loadPartialView('/GA4TagManager/GA4RentalItemsResult', data, (resp) => {
                this.initData = {
                    item_list_id: resp.gTMEcommerce.ecommerceData.item_list_id,
                    item_list_name: resp.gTMEcommerce.ecommerceData.item_list_name,
                    items: resp.gTMEcommerce.ecommerceData.items,
                    event: resp.gTMEcommerce.Event,
                    caller: 'RentalViewList'
                };
                this.sendData(this.initData);
            }, silent);
        }
    }

    proceedToCheckoutGA4() {
        let data = {};
        AxessViewer.loadPartialView('/GA4TagManager/GA4ProceedToCheckoutResult', data, (resp) => {
            let respData: AxGA4initDataExtendedCurAndVal = {
                items: resp.gTMEcommerce.ecommerceData.items,
                event: resp.gTMEcommerce.Event,
                caller: 'ProceedToCheckout',
                value: resp.gTMEcommerce.ecommerceData.value,
                currency: resp.gTMEcommerce.ecommerceData.currency
            };
            this.sendDataExtended(respData);
        }, silent);
    }

    lessonsInfo(value: any[]) {
        let data = value;
        if (this.initData.caller == 'Lessons') {
            AxessViewer.loadPartialView('/GA4TagManager/GA4LessonsResult', data, (resp) => {
                this.initData = {
                    item_list_id: resp.gTMEcommerce.ecommerceData.item_list_id,
                    item_list_name: resp.gTMEcommerce.ecommerceData.item_list_name,
                    items: resp.gTMEcommerce.ecommerceData.items,
                    event: resp.gTMEcommerce.Event,
                    caller: 'Lessons'
                };
                this.sendData(this.initData);
            }, silent);
        }
        if (this.initData.caller == 'Lesson') {
            AxessViewer.loadPartialView('/GA4TagManager/GA4LessonResult', data, (resp) => {
                this.initData = {
                    item_list_id: resp.gTMEcommerce.ecommerceData.item_list_id,
                    item_list_name: resp.gTMEcommerce.ecommerceData.item_list_name,
                    items: resp.gTMEcommerce.ecommerceData.items,
                    event: resp.gTMEcommerce.Event,
                    caller: 'Lesson'
                };
                this.sendData(this.initData);
            }, silent);
        }
    }

    calendarBookNow(value: any[]) {
        let data = { item: value };
        if (this.initData.caller == 'TicketsCalendarBookNow') {
            AxessViewer.loadPartialView('/GA4TagManager/GA4CalendarTicketsResult', data, (resp) => {
                this.initData = {
                    item_list_id: resp.gTMEcommerce.ecommerceData.item_list_id,
                    item_list_name: resp.gTMEcommerce.ecommerceData.item_list_name,
                    items: resp.gTMEcommerce.ecommerceData.items,
                    event: resp.gTMEcommerce.Event,
                    caller: 'TicketsCalendarBookNow'
                };
                this.sendData(this.initData);
            }, silent);
        }
        if (this.initData.caller == 'PackagesCalendarBookNow') {
            AxessViewer.loadPartialView('/GA4TagManager/GA4CalendarPackagesResult', data, (resp) => {
                this.initData = {
                    item_list_id: resp.gTMEcommerce.ecommerceData.item_list_id,
                    item_list_name: resp.gTMEcommerce.ecommerceData.item_list_name,
                    items: resp.gTMEcommerce.ecommerceData.items,
                    event: resp.gTMEcommerce.Event,
                    caller: 'PackagesCalendarBookNow'
                };
                this.sendData(this.initData);
            }, silent);
        }
    }

    quantityBookNow(value: any[]) {
        let data = { item: value };
        if (this.initData.caller == 'TicketsQuantityBookNow') {
            AxessViewer.loadPartialView('/GA4TagManager/GA4QuantityTicketsResult', data, (resp) => {
                this.initData = {
                    item_list_id: resp.gTMEcommerce.ecommerceData.item_list_id,
                    item_list_name: resp.gTMEcommerce.ecommerceData.item_list_name,
                    items: resp.gTMEcommerce.ecommerceData.items,
                    event: resp.gTMEcommerce.Event,
                    caller: 'TicketsQuantityBookNow'
                };
                this.sendData(this.initData);
            }, silent);
        }
        if (this.initData.caller == 'PackagesQuantityBookNow') {
            AxessViewer.loadPartialView('/GA4TagManager/GA4QuantityPackagesResult', data, (resp) => {
                this.initData = {
                    item_list_id: resp.gTMEcommerce.ecommerceData.item_list_id,
                    item_list_name: resp.gTMEcommerce.ecommerceData.item_list_name,
                    items: resp.gTMEcommerce.ecommerceData.items,
                    event: resp.gTMEcommerce.Event,
                    caller: 'PackagesQuantityBookNow'
                };
                this.sendData(this.initData);
            }, silent);
        }
    }

    purchase(value: any[]) {
        let data = { orderNr: value };
        AxessViewer.loadPartialView('/GA4TagManager/Purchase', data, (resp) => {
            let respData: AxGA4initDataExtendedWithTransactionID = {
                items: resp.gTMEcommerce.ecommerceData.items,
                event: resp.gTMEcommerce.Event,
                caller: 'GA4Payment',
                value: resp.gTMEcommerce.ecommerceData.value,
                currency: resp.gTMEcommerce.ecommerceData.currency,
                transaction_id: resp.gTMEcommerce.ecommerceData.transactionId,
                tax: resp.gTMEcommerce.ecommerceData.tax,
                shipping: resp.gTMEcommerce.ecommerceData.shipping,
                coupon: resp.gTMEcommerce.ecommerceData.coupon
            };
            this.sendDataExtendedWithTransactionID(respData);
        }, silent);
    }

    goToBag() {
        AxessViewer.loadPartialView('/GA4TagManager/GA4GoToBagResult', "", (resp) => {
            let data: AxGA4initDataExtendedCurAndVal = {
                items: resp.gTMEcommerce.ecommerceData.items,
                event: resp.gTMEcommerce.Event,
                caller: 'GA4GoToBagResult',
                value: resp.gTMEcommerce.ecommerceData.value,
                currency: resp.gTMEcommerce.ecommerceData.currency
            };
            this.sendDataExtended(data);
        }, silent);
    }

    removeItemFromCart(value: any) {
        let data = { targetPositionId: value };
        AxessViewer.loadPartialView('/GA4TagManager/GA4RemoveItemFromCartResult', data, (resp) => {
            this.initData = {
                item_list_id: resp.gTMEcommerce.ecommerceData.item_list_id,
                item_list_name: resp.gTMEcommerce.ecommerceData.item_list_name,
                items: resp.gTMEcommerce.ecommerceData.items,
                event: resp.gTMEcommerce.Event, caller: 'GetGA4RemoveItemFromCart'
            };
            this.sendData(this.initData);
        }, silent);
    }

    getGridderDataForPackage(argPackageNr: string, argTariffSheetNr: string) {
        let packageData: RentalPackageParam = { PackNr: argPackageNr, TariffsheetNr: argTariffSheetNr };
        let data = { itemParam: packageData };

        AxessViewer.loadPartialView('/GA4TagManager/GA4RentalPackageResult', data, (resp) => {
            this.initData = {
                item_list_id: resp.gTMEcommerce.ecommerceData.item_list_id,
                item_list_name: resp.gTMEcommerce.ecommerceData.item_list_name,
                items: resp.gTMEcommerce.ecommerceData.items,
                event: resp.gTMEcommerce.Event, caller: 'GetGA4RentalPackage'
            };
            this.sendData(this.initData);
        }, silent);
    }

    getGridderDataForRental(rentalItem: string) {
        let jsonObj: RentalSingleItemParam = JSON.parse(rentalItem);
        let itemParam: RentalSingleItemParam = this.parseRentalItem(jsonObj);
        let data = { itemParam };
        AxessViewer.loadPartialView('/GA4TagManager/GA4RentalItemResult', data, (resp) => {
            this.initData = {
                item_list_id: resp.gTMEcommerce.ecommerceData.item_list_id,
                item_list_name: resp.gTMEcommerce.ecommerceData.item_list_name,
                items: resp.gTMEcommerce.ecommerceData.items,
                event: resp.gTMEcommerce.Event, caller: 'GetGA4RentalRentalItem'
            };
            this.sendData(this.initData);
        }, silent);
    }

    sendData(init: AxGA4initDataListIdAndListName) {
        this.showLog(init);
        if (init.event == '') { return; }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(function () { this.reset(); });  // Clear the previous ecommerce object.
        window.dataLayer.push({
            event: init.event,
            ecommerce:
            {
                item_list_id: init.item_list_id,
                item_list_name: init.item_list_name,
                items: init.items
            }
        });
    }

    sendDataExtended(init: AxGA4initDataExtendedCurAndVal) {
        const configModule = AxLoad.GetModule<AxStaticConfigModule>('AxStaticConfigModule');
        this.showLog(init);
        if (init.event == '') { return; }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(function () { this.reset(); });  // Clear the previous ecommerce object.
        window.dataLayer.push({
            event: init.event,
            ecommerce:
            {
                currency: init.currency,
                value: init.value,
                items: init.items
            }
        });
        if (this.initData.redirect && configModule.skipAddedToCartPopup) {
            $('body').trigger('goToShoppingCartRedirect', this.initData.redirect);
        }
    }

    sendDataExtendedWithPayment(init: AxGA4initDataExtendedWithPaymentType) {
        this.showLog(init);
        if (init.event == '') { return; }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(function () { this.reset(); });  // Clear the previous ecommerce object.
        window.dataLayer.push({
            event: init.event,
            ecommerce:
            {
                payment_type: init.payment_type,
                currency: init.currency,
                value: init.value,
                coupon: init.coupon,
                items: init.items
            }
        });
    }

    sendDataExtendedWithTransactionID(init: AxGA4initDataExtendedWithTransactionID) {
        this.showLog(init);
        if (init.event == '') { return; }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(function () { this.reset(); });  // Clear the previous ecommerce object.
        window.dataLayer.push({
            event: init.event,
            ecommerce:
            {
                transaction_id: init.transaction_id,
                tax: init.tax,
                shipping: init.shipping,
                coupon: init.coupon,
                currency: init.currency,
                value: init.value,
                items: init.items
            }
        });
    }

    showLog(init: AxGA4initData) {
        /*console.log(init);*/
    }
}

interface AxGA4initData {
    event: string;
    caller: string;
    items: any[];
    redirect?: string;
}
interface AxGA4initDataListIdAndListName extends AxGA4initData {
    item_list_id: string;
    item_list_name: string;
}
interface AxGA4initDataExtendedCurAndVal extends AxGA4initData {
    currency: string;
    value: number;
}
interface AxGA4initDataExtendedWithTransactionID extends AxGA4initDataExtendedCurAndVal {
    transaction_id: string;
    tax: number;
    shipping: string;
    coupon: string;
}
interface AxGA4initDataExtendedWithPaymentType extends AxGA4initDataExtendedCurAndVal {
    payment_type: string;
    coupon: string;
}
interface RentalSingleItemParam {
    RentalNr: string;
    ValidFrom: string;
    ValidTo: string;
}
interface RentalItemParamCollection {
    ItemParams: RentalSingleItemParam[];
}
interface RentalPackageParam {
    PackNr: string;
    TariffsheetNr: string;
}
interface RentalPackageParamCollection {
    ItemParams: RentalPackageParam[];
}

declare global {
    export interface Window {
        dataLayer?: object[];
    }
}